module.exports = __webpack_public_path__ + "img/2.a0b3b391.jpg";